import React from 'react'

import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { useThrottledCallback } from 'use-debounce'
import { DS } from '@/design-system'
import type { DSTypographyVariant } from '@/design-system/Typography'
import { useCheatSheet } from '@/components/CheatSheet/useCheatSheet'
import type { DSColor } from '@ppwr/poker'

import { DiamondCountDisplay } from '@/components/Diamonds/Diamonds'

import * as cth from '@/router/(root)/cth/cthModule'
import * as d10 from '@/router/(root)/daily10/d10Module'
import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'

import { defaultTheme } from '@/components/Mini/theme'

type GameHeaderProps = {
  title?: string
  showDiamonds?: boolean
  showKey?: boolean
  handler?: () => void
}

function PocketPickHeader({title, showDiamonds=true, showKey=false, handler }: GameHeaderProps) {

  const theme = pocketPick.useStore(s => s.theme);

  return (
    <Header theme={theme} title={title} showDiamonds={showDiamonds} showKey={showKey} handler={handler}/>  
  )

}

function CthHeader({title, showDiamonds=true, showKey=false, handler }: GameHeaderProps) {

  const theme = cth.useStore(s => s.theme);

  return (
    <Header theme={theme} title={title} showDiamonds={showDiamonds} showKey={showKey} handler={handler}/>  
  )

}

function D10Header({title, showDiamonds=true, showKey=false, handler }: GameHeaderProps) {

  const theme = d10.useStore(s => s.theme);

  return (
    <Header theme={theme} title={title} showDiamonds={showDiamonds} showKey={showKey} handler={handler}/>  
  )

}


type HeaderProps = {
  title?: string
  variant?: DSTypographyVariant
  handler?: () => void
  theme: {accent: string, icon: DSColor}
  showDiamonds?: boolean
  showKey?: boolean
}

function Header({theme=defaultTheme, title, variant="Body Large/Medium", showDiamonds, showKey, handler}: HeaderProps) {

  const titleColor = theme.accent 
  const iconColor = theme.icon;

  const { open: openCheatSheet } = useCheatSheet()
  const onOpenCheatSheet = useThrottledCallback(() => openCheatSheet(), 350)

  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={handler} hitSlop={12}>
        <DS.Icon name="Arrow---left" size={24} color={iconColor} />
      </TouchableOpacity>

      <DS.Text variant={variant} style={[styles.title, { color: titleColor }]}>
        {title}
      </DS.Text>

      {showDiamonds &&
        <DiamondCountDisplay textColor={DS.palette[iconColor]} />
      }

      {showKey &&
        <TouchableOpacity onPress={onOpenCheatSheet} style={styles.keyRow}>
          <DS.Text variant="Caption/Regular" color={iconColor}>Key</DS.Text>
          <DS.Icon name="Key" size={24} color={iconColor} />
        </TouchableOpacity>
      }

      {!showKey && ! showDiamonds &&
        <View style={styles.rightSpacer} />
      }

    </View>
  )
}


export { Header, CthHeader, D10Header, PocketPickHeader }

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: 58,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    gap: 8
  },
  title: {
    flex: 1,
    textAlign: 'center'
  },
  keyRow: {
    flexDirection: 'row',
    gap: 6,
    alignItems: 'center'
  },
  rightSpacer: {
    width: 24
  }
})



